import api from '@/common/api';
import Vue from 'vue';
import { cloneDeep } from 'lodash';

const initialState = () => ({
  loading: {
    load: false,
    create: false,
    edit: false,
    loadResults: false,
    manager: false,
    editMail: false,
  },
  errors: {
    load: [],
    create: [],
    loadResults: [],
    manager: [],
    edit: [],
  },
  count: 0,
  managers: [],
  manager: null,
  selected: [],
  editedManager: null,
  dialogCreateShow: false,
  dialogEditShow: false,
  managerStats: {
    currentManagerId: null,
    total_sent: null,
    tests: [],
    date: null,
  },

  filter: {
    page_size: 20,
    page: 1,
    name: '',
    email: '',
    company: '',
    corp_client: '',
    tab: '',
    dateStart: '',
    dateEnd: '',
    currentStatus: '',
    nomenclature_code: '',
  },
  totalAmount: 0,

  // Отдельно от filter/managers выше — под поиск в выпадающем списке (ExpertFormDialog
  // календаря записи), где нужен весь набор совпадений без пагинации, а не одна страница
  // общего списка менеджеров с его собственным filter.page_size.
  bookingSearch: {
    loading: false,
    results: [],
  },
});

export default {
  namespaced: true,
  state: cloneDeep(initialState()),
  actions: {
    async loadManagers({ commit }) {
      commit('loadManagersRequest');
      try {
        const response = await api.get('/users/managers/?page_size=-1');
        commit('setManagers', response);
        commit('setCount', response.lenght);
        commit('loadManagersSuccess');
        return response;
      } catch (err) {
        commit('loadManagersFailure', Object.entries(err.data));
        throw err;
      }
    },

    // page_size=-1 отключает пагинацию бэка целиком — иначе совпадение может оказаться
    // не на первой странице обычного постраничного списка и не найтись никогда.
    async searchManagersForBooking({ commit }, name) {
      commit('setBookingSearchLoading', true);
      try {
        const params = { page_size: -1 };
        if (name) params.name = name;
        const response = await api.get('/users/managers/', { params });
        commit('setBookingSearchResults', Array.isArray(response) ? response : []);
      } catch (err) {
        commit('setBookingSearchResults', []);
      } finally {
        commit('setBookingSearchLoading', false);
      }
    },

    async loadManagersFilter({
      commit,
      getters
    }) {
      commit('loadManagersRequest');
      try {
        let filter = '';
        Object.keys(getters.filter)
          .forEach((key) => {
            // if (Array.isArray(getters.filter[key])) {
            //   if (getters.filter[key].length) {
            //     filter[key] = getters.filter[key];
            //   }
            //   return;
            // }
            if (getters.filter[key]) {
              if (filter) {
                filter += '&';
              }
              filter += `${key}=${encodeURIComponent(getters.filter[key])}`;
            }
          });

        if (filter) {
          filter = `?${filter}`;
        }
        const response = await api.get(`/users/managers/${filter}`);
        commit('setManagers', response.results);
        commit('setCount', response.count);
        commit('loadManagersSuccess');
        return response;
      } catch (err) {
        commit('loadManagersFailure', Object.entries(err.data));
        throw err;
      }
    },

    async loadManagersForExport({
      commit,
      getters
    }) {
      commit('loadManagersRequest');
      try {
        let filter = '?page_size=-1';
        Object.keys(getters.filter)
          .forEach((key) => {
            if (key === 'page' || key === 'page_size') return;
            if (getters.filter[key]) {
              filter += `&${key}=${encodeURIComponent(getters.filter[key])}`;
            }
          });

        const response = await api.get(`/users/managers/${filter}`);
        commit('loadManagersSuccess');
        return response;
      } catch (err) {
        commit('loadManagersFailure', Object.entries(err.data));
        throw err;
      }
    },

    async loadManagersResults({
      commit,
      getters
    }) {
      commit('loadManagersResultsRequest');
      const data = {
        candidates: getters.selected,
      };
      try {
        const response = await api.post('/users/candidates/get-test-result/', data);
        commit('loadManagersResultsSuccess');
        return response;
      } catch (err) {
        commit('loadManagersResultsFailure', Object.entries(err.data));
        throw err;
      }
    },

    async createManager({
      commit,
      dispatch
    }, data) {
      commit('createManagerRequest');
      try {
        await api.post('/users/managers/', data);
        commit('createManagerSuccess');
        dispatch('loadManagersFilter');
      } catch (err) {
        commit('createManagerFailure', Object.entries(err.data));
        throw err;
      }
    },
    async loadManager({ commit }, id) {
      commit('loadManagerRequest');
      let manager = null;
      const counters = null;
      try {
        manager = await api.get(`/users/managers/${id}/`);
      } catch (err) {
        commit('loadManagerFailure', Object.entries(err.data));
        throw err;
      }

      // try {
      //   counters = await api.get(`/test-amount/${id}/`);
      // } catch (err) {
      //   console.log(err);
      // }

      commit('loadManagerSuccess', {
        manager,
        counters
      });
    },
    async saveManager({
      commit,
      dispatch
    }, data) {
      commit('editManagerRequest');
      try {
        await api.patch(`/users/managers/${data.id}/`, data);
        commit('editManagerSuccess');
        dispatch('loadManagersFilter');
        dispatch('loadManager', data.id);
      } catch (err) {
        commit('editManagerFailure', Object.entries(err.data));
        throw err;
      }
    },
    clearError({ commit }) {
      commit('clearError');
    },
    setSelected({ commit }, id) {
      commit('setSelected', id);
    },
    allSelected({ commit }) {
      commit('allSelected');
    },
    clearSelected({ commit }) {
      commit('clearSelected');
    },
    setDialogCreateShow({ commit }, bool) {
      if (!bool) commit('setEditedManager', null);
      commit('setDialogCreateShow', bool);
    },
    setDialogEditShow({ commit }, bool) {
      if (!bool) commit('setEditedManager', null);
      commit('setDialogEditShow', bool);
    },
    async setManagerSendMail({ commit }, data) {
      commit('editMailRequest');
      try {
        const response = await api.patch(`/users/managers/${data.id}/`, data);
        commit('editMailSuccess');
        commit('setSendMail', response);
      } catch (err) {
        commit('editMailFailure', Object.entries(err.data));
        throw err;
      }
    },
    async setFilterPage({
      commit,
      dispatch
    }, page) {
      commit('setFilterPage', page);
      await dispatch('loadManagersFilter');
    },
    async setFilterPageSize({
      commit,
      dispatch
    }, payload) {
      commit('setFilterPage', payload.page);
      commit('setFilterPageSize', payload.pageSize);
      await dispatch('loadManagersFilter');
    },
    async setFilterName({
      commit,
      dispatch
    }, name) {
      commit('setFilterName', name);
      commit('setFilterPage', 1);
      await dispatch('loadManagersFilter');
    },
    async setFilterEmail({
      commit,
      dispatch
    }, email) {
      commit('setFilterEmail', email);
      commit('setFilterPage', 1);
      await dispatch('loadManagersFilter');
    },
    async setFilterCompany({
      commit,
      dispatch
    }, payload) {
      commit('setFilterCompany', payload);
      commit('setFilterPage', 1);
      await dispatch('loadManagersFilter');
    },
    async setFilterAll({
      commit,
      dispatch
    }, params) {
      commit('setFilterPage', parseInt(params.page, 10) || 1);
      commit('setFilterName', params.name ?? '');
      commit('setFilterEmail', params.email ?? '');
      commit('setFilterCompany', params.company ?? '');
      commit('setFilterCorpClient', params.corp_client ?? '');
      await dispatch('loadManagersFilter');
    },
    async setCorpClientFilter({ commit, dispatch }, corpId) {
      commit('setFilterCorpClient', corpId || '');
      commit('setFilterPage', 1);
      await dispatch('loadManagersFilter');
    },
    async clearFilterAll({
      commit,
      dispatch
    }) {
      commit('setFilterName', '');
      commit('setFilterEmail', '');
      commit('setFilterCompany', '');
      commit('setFilterCorpClient', '');
      await dispatch('loadManagersFilter');
    },
    async setFilterNameWithData({
      commit,
      dispatch
    }, {
      name,
      tab,
      dateStart,
      dateEnd,
      currentStatus
    }) {
      if (tab) {
        commit('setFilterTab', tab);
      }
      if (dateStart) {
        commit('setFilterDateStart', dateStart);
      }
      if (dateEnd) {
        commit('setFilterDateEnd', dateEnd);
      }
      if (currentStatus) {
        commit('setFilterStatus', currentStatus);
      }
      commit('setFilterName', name);
      commit('setFilterPage', 1);
      await dispatch('loadManagersFilter');
    },
    async setStatsManger({ commit }, data) {
      try {
        const response = await api.post('/sent-tests-tracking/stats/', data);
        commit('setManagerId', data.manager_id);
        if (data.start_date) {
          commit('setStatsPeriod', { start_date: `${data.start_date}`, end_date: `${data.end_date}` });
        } else {
          commit('setStatsPeriod', null);
        }
          commit('setStatsManger', { tests: response.by_test, total_sent: response.total_sent });
      } catch (err) {
        return err;
      }
    },
    resetStatsManager({ commit }) {
      commit('setManagerId', null);
      commit('setStatsPeriod', null);
      commit('setStatsManger', { tests: [], total_sent: 0 });
    },
    async setFilterNomenclature({
      commit,
      dispatch
    }, code) {
      commit('setFilterNomenclature', code);
      await dispatch('loadManagersFilter');
    },
    async getTotalCounters({ commit }, data) {
      try {
        const response = data.nomenclature_code
          ? await api.get(`/counters/stock-amounts/total-amount/?nomenclature_code=${data.nomenclature_code}`)
          : await api.get('/counters/stock-amounts/total-amount/');
        commit('setTotalAmount', response.total_amount);
      } catch (err) {
        return err;
      }
    }
  },
  mutations: {
    loadManagersRequest(state) {
      state.loading.load = true;
      state.errors.load = [];
    },
    loadManagersSuccess(state) {
      state.loading.load = false;
    },
    loadManagersFailure(state, error) {
      state.errors.load = error;
      state.loading.load = false;
    },

    loadManagersResultsRequest(state) {
      state.loading.loadResults = true;
      state.errors.loadResults = [];
    },
    loadManagersResultsSuccess(state) {
      state.loading.loadResults = false;
    },
    loadManagersResultsFailure(state, error) {
      state.errors.loadResults = error;
      state.loading.loadResults = false;
    },

    createManagerRequest(state) {
      state.loading.create = true;
      state.errors.create = [];
    },
    createManagerSuccess(state) {
      state.loading.create = false;
    },
    createManagerFailure(state, error) {
      state.errors.create = error;
      state.loading.create = false;
    },

    loadManagerRequest(state) {
      state.loading.manager = true;
      state.errors.manager = [];
    },

    loadManagerSuccess(state, { manager, counters }) {
      Vue.set(manager, 'counters', counters);
      state.manager = manager;
      state.loading.manager = false;
    },

    loadManagerFailure(state, error) {
      state.errors.manager = error;
      state.loading.manager = false;
    },

    editManagerRequest(state) {
      state.loading.edit = true;
      state.errors.edit = [];
    },
    editManagerSuccess(state) {
      state.loading.edit = false;
    },
    editManagerFailure(state, error) {
      state.errors.edit = error;
      state.loading.edit = false;
    },

    setCount(state, count) {
      state.count = count;
    },
    clearSelected(state) {
      state.selected = [];
    },
    clearError(state) {
      state.errors = initialState().errors;
    },
    setManagers(state, managers) {
      state.managers = managers;
    },

    setSelected(state, id) {
      if (id || id === 0) {
        const itemFound = state.selected.some((item) => item === id);
        if (itemFound) {
          state.selected = state.selected.filter((item) => item !== id);
        } else {
          state.selected.push(id);
        }
      } else {
        state.selected = [];
      }
    },
    allSelected(state) {
      state.managers.forEach((c) => {
        if (!state.selected.some((id) => c.id === id)) {
          state.selected.push(c.id);
        }
      });
    },
    setEditedManager(state, manager) {
      state.editedManager = manager;
    },
    setDialogCreateShow(state, bool) {
      state.dialogCreateShow = bool;
    },
    setDialogEditShow(state, bool) {
      state.dialogEditShow = bool;
    },

    setSendMail(state, data) {
      state.manager.send_mail = data.send_mail;
    },
    editMailRequest(state) {
      state.loading.editMail = true;
      state.errors.edit = [];
    },
    editMailSuccess(state) {
      state.loading.editMail = false;
    },
    editMailFailure(state, error) {
      state.errors.edit = error;
      state.loading.editMail = false;
    },
    reset(state) {
      // console.log('state1', state);
      // console.log('initialState()', initialState());
      Object.assign(state, initialState());
      // console.log('state2', state);
      // console.log('state2', this);
    },
    setFilterPage(state, page) {
      state.filter.page = parseInt(page, 10);
    },
    setFilterPageSize(state, pageSize) {
      state.filter.page_size = parseInt(pageSize, 10);
    },
    setFilterName(state, name) {
      state.filter.name = name;
    },
    setFilterEmail(state, email) {
      state.filter.email = email;
    },
    setFilterCompany(state, payload) {
      state.filter.company = payload;
    },
    setFilterCorpClient(state, payload) {
      state.filter.corp_client = payload;
    },
    setFilterTab(state, payload) {
      state.filter.tab = payload;
    },
    setFilterDateStart(state, date) {
      state.filter.dateStart = date;
    },
    setFilterDateEnd(state, date) {
      state.filter.dateEnd = date;
    },
    setFilterStatus(state, status) {
      state.filter.currentStatus = status;
    },
    setManagerId(state, id) {
      state.managerStats.currentManagerId = id;
    },
    setStatsManger(state, stats) {
      if (stats.total_sent) {
        state.managerStats.tests = stats.tests;
        state.managerStats.total_sent = stats.total_sent;
      } else {
        state.managerStats.tests = [];
        state.managerStats.total_sent = 0;
      }
    },
    setStatsPeriod(state, stats) {
      if (!stats) {
        state.managerStats.date = null;
        return;
      }
      state.managerStats.date = { start_date: stats.start_date, end_date: stats.end_date };
    },
    setFilterNomenclature(state, code) {
      state.filter.nomenclature_code = code;
    },
    setTotalAmount(state, totalAmount) {
      state.totalAmount = totalAmount;
    },
    setBookingSearchLoading(state, value) {
      state.bookingSearch.loading = value;
    },
    setBookingSearchResults(state, results) {
      state.bookingSearch.results = results;
    },
  },
  getters: {
    loading: (state) => state.loading,
    errors: (state) => state.errors,
    count: (state) => state.count,
    managers: (state) => state.managers,
    filter: (state) => state.filter,
    manager: (state) => state.manager,
    selected: (state) => state.selected,
    editedManager: (state) => state.editedManager,
    dialogCreateShow: (state) => state.dialogCreateShow,
    dialogEditShow: (state) => state.dialogEditShow,
    isFilterEmpty: (state) => !state.filter.name && !state.filter.email && !state.filter.company && !state.filter.corp_client,
    statsManager: (state) => state.managerStats,
    totalAmount: (state) => state.totalAmount,
    bookingSearchResults: (state) => state.bookingSearch.results,
    bookingSearchLoading: (state) => state.bookingSearch.loading,
  },
};
